import { acquireEndpoint } from "utils/SmartMerchandiserAPI";
import { takeEvery, call, put } from "typed-redux-saga/macro";
import { callApi } from "utils/SagaUtils";
import { getData, postData } from "services/ApiService";
import {
  SUBMIT_SYNC_CATEGORIES,
  SyncCategoriesRequestAction,
  SYNC_CATEGORIES_SERVICE_URL,
  FETCH_SYNC_JOB_DETAILS,
  SyncJobDetailsRequestAction,
  FETCH_CATEGORY_LATEST_SYNC,
  FetchCategoryLatestsSyncAction,
  LATEST_SYNC_JOB_NOT_FOUND,
} from "./SyncCategoriesTypes";
import { addGlobalAlertState } from "store/global-alert/GlobalAlertActions";

function* submitSyncCategories(action: SyncCategoriesRequestAction) {
  try {
    const actionType = SUBMIT_SYNC_CATEGORIES;
    const serviceType = SYNC_CATEGORIES_SERVICE_URL;
    const constName = Object.keys({
      SUBMIT_SYNC_CATEGORIES,
    })[0].toString();
    const endpoint = acquireEndpoint(constName, serviceType);
    yield* call(callApi, actionType, postData, action.payload, endpoint);
  } catch (e: any) {
    console.error(e);
    yield* put({
      type: SUBMIT_SYNC_CATEGORIES.FAILURE,
      message: e.message,
    });
  }
}

function* fetchCategorySyncJobDetails(action: SyncJobDetailsRequestAction) {
  try {
    const actionType = FETCH_SYNC_JOB_DETAILS;
    const serviceType = SYNC_CATEGORIES_SERVICE_URL;
    const { syncJobId } = action.payload;
    const constName = Object.keys({
      FETCH_SYNC_JOB_DETAILS,
    })[0].toString();
    const endpoint = acquireEndpoint(constName, serviceType, syncJobId);
    yield* call(callApi, actionType, getData, null, endpoint);
  } catch (e: any) {
    console.error(e);
    yield* put({
      type: FETCH_SYNC_JOB_DETAILS.FAILURE,
      message: e.message,
    });
  }
}

function* fetchCategoryLatestsSync(action: FetchCategoryLatestsSyncAction) {
  try {
    const actionType = FETCH_CATEGORY_LATEST_SYNC;
    const serviceType = SYNC_CATEGORIES_SERVICE_URL;
    const constName = Object.keys({
      FETCH_CATEGORY_LATEST_SYNC,
    })[0].toString();
    const { catalogId, categoryId } = action.payload;
    const endpoint = acquireEndpoint(
      constName,
      serviceType,
      catalogId,
      categoryId,
    );
    const optionsObj = {
      showGenericError: false,
    };
    const result = yield* call(
      callApi,
      actionType,
      getData,
      null,
      endpoint,
      {},
      optionsObj,
    );
    if (
      result &&
      result.type === actionType.FAILURE &&
      result.reason !== LATEST_SYNC_JOB_NOT_FOUND
    ) {
      yield* put(
        addGlobalAlertState({
          alertsProps: [
            {
              descriptor: {
                id: "syncCategories.fetchCategoryLatestsSyncFailure",
                defaultMessage: "Unable to fetch category latest sync",
              },
              severity: "error",
              variant: "standard",
            },
          ],
        }),
      );
    }
  } catch (e: any) {
    console.error(e);
    yield* put({
      type: FETCH_CATEGORY_LATEST_SYNC.FAILURE,
      message: e.message,
    });
  }
}

export function* watchSubmitSyncCategoriesRequest() {
  yield* takeEvery(SUBMIT_SYNC_CATEGORIES.REQUEST, submitSyncCategories);
}

export function* watchFetchSyncJobDetails() {
  yield* takeEvery(FETCH_SYNC_JOB_DETAILS.REQUEST, fetchCategorySyncJobDetails);
}

export function* watchFetchCategoryLatestsSync() {
  yield* takeEvery(
    FETCH_CATEGORY_LATEST_SYNC.REQUEST,
    fetchCategoryLatestsSync,
  );
}
